import classNames from 'classnames';

const UNPUBLISHED_STATUSES = new Set(['NOT_PUBLISHED', 'NOT_FOUND', 'ERROR']);

export const STOREFRONT_STATUS_TOOLTIP =
    'Reflects the last check against the store itself, not the CMS. ' +
    'PUBLISHED means the SKU is live and purchasable there: on Google Play the ' +
    'product has at least one active purchase option; on the App Store the ' +
    'in-app purchase is APPROVED in App Store Connect. NOT_PUBLISHED, NOT_FOUND ' +
    'and ERROR mean it failed that check, and NOT_SYNCED means it was never ' +
    'checked — use "Sync with ..." to re-check.';

/**
 * Renders the last-synced storefront status of a SKU. A missing status means
 * the SKU has never been synced, which is shown explicitly as NOT_SYNCED.
 * Stores without a storefront concept are not rendered by this component.
 */
export function StorefrontStatusText({ status }: { status?: string | null }) {
    const resolved = status ?? 'NOT_SYNCED';
    return (
        <span
            className={classNames(
                'status',
                UNPUBLISHED_STATUSES.has(resolved) && 'invalid',
            )}
        >
            {resolved}
        </span>
    );
}
